import { Map, fromJS } from 'immutable';

export function request(state) {
    return state.set(
        'add-value',
        (state.get('add-value') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );
}

export function error(state, { errors }) {
    return state.set(
        'add-value',
        (state.get('add-value') || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(errors))
    );
}

export function finish(state) {
    state = state
        .set(
            'add-value',
            (state.get('add-value') || Map())
                .set('state', 'FINISHED')
                .set('errors', void 0)
        );

    return state;
}

export function clear(state) {
    return state.set('add-value', Map());
}
